module.exports = __webpack_public_path__ + "villafinder-logo.png?7c3f7bc398ec0ac548a77d884c270d92";